// packages/components/calendar/CalendarMonth.js
import React from "react";
import CalendarDay from "./day";

/**
 * Calendar month grid component
 *
 * @param {Object} props
 * @param {Array<Object>} props.days - Array of day objects for the month
 * @param {function} props.onSelectDate - Handler for date selection
 * @param {function} [props.renderDay] - Custom day cell renderer
 * @param {boolean} props.isDesktop - Whether the component is rendered on desktop
 */
const CalendarMonth = ({ days, onSelectDate, renderDay, isDesktop }) => {
  if (isDesktop) {
    return (
      <div className="hidden w-full lg:grid lg:grid-cols-7 grid-rows-5 lg:gap-px">
        {days.map((day) => (
          <CalendarDay
            key={day.date}
            day={day}
            onSelect={() => onSelectDate(new Date(day.date))}
            renderDay={renderDay}
            isDesktop={true}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="isolate grid w-full grid-cols-7 grid-rows-5 gap-px lg:hidden">
      {days.map((day) => (
        <CalendarDay
          key={day.date}
          day={day}
          onSelect={() => onSelectDate(new Date(day.date))}
          renderDay={renderDay}
          isDesktop={false}
        />
      ))}
    </div>
  );
};

export default CalendarMonth;
